export { privateKey, setAssignMethod, setAssignAlias, FluentAssignFactory, FluentAssign } from './framework/fluent-assign';
export { extend, arrayUnion, PromiseCompleter } from './framework/utils';
export { createComponent } from './framework/createComponent';
export { DialogBailOutError } from './models/errors';
export { DialogRef } from './models/dialog-ref';
export { DROP_IN_TYPE, OverlayRenderer } from './models/tokens';
export { Modal, DOMOverlayRenderer } from './providers/index';
export { overlayConfigFactory, OverlayContext, OverlayContextBuilder } from './models/overlay-context';
export { Overlay, ModalOverlay, OverlayDialogBoundary, OverlayTarget } from './overlay/index';
export { DEFAULT_VALUES, ModalContext, ModalContextBuilder } from './models/modal-context';
export { ModalOpenContext, ModalOpenContextBuilder } from './models/modal-open-context';
export { BaseDynamicComponent, CSSBackdrop, CSSDialogContainer } from './components/index';
export { ModalModule } from './angular2-modal.module';
//# sourceMappingURL=angular2-modal.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/src/angular2-modal.js
// module id = 23
// module chunks = 0